import { motion } from "framer-motion";
import Link from "next/link";
import { Col, Container, Row } from "reactstrap";
import styles from "./styles.module.scss";

export const MainBanner = ({
  customClass = "",
  content,
  title,
  image,
  displayImage1,
  buttonLink,
  buttonTitle,
  button_1_class,
  returnButtonLink,
  returnButtonTitle,
}) => {
  const variants_1 = {
    hidden: { opacity: 0.005, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.05 } },
  };
  return (
    <section
      className={`${
        styles.root
      } ${customClass} position-relative overflow-hidden ${
        displayImage1 ? null : "hidden-image-1"
      }`}
    >
      <Container>
        <Row className="m-0">
          <Col
            lg={6}
            className="contentWrapper d-flex flex-wrap align-items-center position-relative"
          >
            <div>
              {returnButtonLink ? (
                <Link href={returnButtonLink}>
                  <a className="return-text text-nowrap arrow-left d-inline-flex align-items-center white mb-4">
                    <strong>{returnButtonTitle}</strong>
                  </a>
                </Link>
              ) : (
                ""
              )}
              <motion.div
                initial="hidden"
                animate="visible"
                variants={variants_1}
              >
                <h1>{title}</h1>
                {content ? (
                  <div dangerouslySetInnerHTML={{ __html: content }} />
                ) : null}
              </motion.div>

              {buttonLink && (
                <div className="mt-4">
                  <a
                    href={`${buttonLink}`}
                    className={`${button_1_class} no-arrow m-0`}
                  >
                    {buttonTitle}
                  </a>
                </div>
              )}
            </div>
          </Col>
          {displayImage1 ? (
            <Col lg={6} className="position-relative mainImageWrapper">
              <img
                src={image?.url ? image?.url : "/site-assets/placeholders/img-placeholder.jpg"}
                width={1000}
                alt={image?.alt}
                className="card-img rounded-4"
              />
            </Col>
          ) : null}
        </Row>
        <div className="imageWrapper position-absolute p-0">
          <img
            src={"/site-assets/svg/main-banner-overlay.svg"}
            alt={`main-banner-overlay`}
          />
        </div>
      </Container>
    </section>
  );
};

export default MainBanner;
